import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/quiz/list',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/la/admin/quiz/create',
      data
    });
  },
  update(data) {
    return http.post({
      url: '/la/admin/quiz/update',
      data
    });
  },
  enable(data) {
    return http.post({
      url: '/la/admin/quiz/enable',
      data,
      dataType: 'form'
    });
  },
  disable(data) {
    return http.post({
      url: '/la/admin/quiz/disable',
      data,
      dataType: 'form'
    });
  },
  setResult(data) {
    return http.post({
      url: '/la/admin/quiz/result',
      data,
      dataType: 'form'
    });
  },
  getAllCoins() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  }
};
